import React from 'react'
import { useState, useEffect, useRef } from 'react';
import Select, { components } from 'react-select';
import { AiOutlinePlusCircle, AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import axios from 'axios'
import ToastNotification from '../../../components/ToastNotification';

function FranchiseeArea() {

    const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
    const showToast = (msg, bg = 'success') => {
        setToast({ show: true, message: msg, bg });
    };
    const [company, setCompany] = useState([]);
    const [branch, setBranch] = useState([]);
    const [stateOptions, setStateOptions] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [selectedBranch, setSelectedBranch] = useState(null);
    const [allBranches, setAllBranches] = useState([]);
    const [cityOptions, setCityOptions] = useState([]);
    const [pincodeOptions, setPincodeOptions] = useState([]);
    const [selectedState, setSelectedState] = useState(null);
    const [selectedCity, setSelectedCity] = useState(null);
    const [stateData, setStateData] = useState([]);
    const [cityTableData, setCityTableData] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedRowsByCity, setSelectedRowsByCity] = useState({});

    const handleCompanyChange = (selected) => {
        setSelectedCompany(selected);
        setSelectedBranch(null);

        if (!selected) {
            setBranch([]);
            return;
        }
        const filteredBranches = allBranches.filter(
            (b) => b.companyId === selected.value
        );

        setBranch(filteredBranches);
    };
    const handleStateChange = (selected) => {
        setSelectedState(selected);
        setSelectedCity(null);
        setCityOptions([]);
        setPincodeOptions([]);

        if (selected) {
            fetchDataByState(selected.value);
        }
    };


    const handleCityChange = async (selected) => {
        setSelectedCity(selected);
        if (!selected) {
            setCityTableData([]);
            return;
        }

        const filtered = stateData.filter(item => item.city === selected.value);
        setCityTableData(filtered);

        try {
            const response = await axios.get('https://api.skyguard.group/api/get-selections', {
                params: {
                    companyId: selectedCompany.value,
                    branchId: selectedBranch.value,
                    state: selectedState.value,
                    city: selected.value,
                }
            });

            const savedRegions = Array.isArray(response.data)
                ? response.data
                : JSON.parse(response.data.region_with_pincode || "[]");

            setSelectedRowsByCity(prev => ({
                ...prev,
                [selected.value]: savedRegions.map(item => ({ ...item, pincode: String(item.pincode) }))
            }));

        } catch (err) {
            console.error("Error fetching saved selections:", err);
        }
    };


    const handleCheckboxChange = (row, isChecked) => {
        const city = selectedCity?.value;
        if (!city) {
            showToast("No city selected, cannot update checkbox",'warning');
            return;
        }
        const rowNormalized = { ...row, pincode: String(row.pincode) };
        setSelectedRowsByCity(prev => {
            const currentRows = prev[city] || [];
           

            let updatedRows;
            if (isChecked) {
                // Avoid duplicates
                updatedRows = currentRows.some(r => r.pincode === rowNormalized.pincode)
                    ? currentRows
                    : [...currentRows, rowNormalized];
            } else {
                updatedRows = currentRows.filter(r => r.pincode !== rowNormalized.pincode);
            }

            const newState = {
                ...prev,
                [city]: updatedRows
            };
            return newState;
        });
    };



    const handleSubmit = async (e) => {
        e.preventDefault();

        const allSelectedRegions = Object.values(selectedRowsByCity).flat();
        if (!selectedCompany || !selectedBranch || !selectedState || !selectedCity) {
            showToast("Please fill all required fields", "warning");
            return;
        }

        if (allSelectedRegions.length === 0) {
            showToast("Please select at least one pincode", "warning");
            return;
        }

        try {
            await axios.post('https://api.skyguard.group/api/franchisee-call-area', {
                companyId: selectedCompany.value,
                branchId: selectedBranch.value,
                state: selectedState.value,
                city: selectedCity.value,
                regions: allSelectedRegions
            });

            showToast("Data saved successfully", "success");
           

        } catch (err) {
            console.error("Error saving selections:", err);
            showToast("Error saving data", "danger");
        }
    };

    const handleCancel = () => {
        setSelectedCompany(null);
        setSelectedBranch(null);
        setSelectedState(null);
        setSelectedCity(null);

        setBranch([]);
        setCityOptions([]);
        setCityTableData([]);
        setSelectedRows([]);
    };


    const fecthCompanyDetail = async () => {
        try {
            const resDetail = await axios.get('https://api.skyguard.group/api/fetch-detail');

            const options = resDetail.data.result.map((item) => ({
                value: item.id,
                label: item.name,
            }));

            setCompany(options);
        } catch (error) {
            console.log(error)
        }
    };

    const fecthBranchDetail = async () => {
        try {
            const res = await axios.get('https://api.skyguard.group/api/fetch-branch');

            const options = res.data.result.map((item) => ({
                value: item.id,
                label: item.name,
                companyId: item.company_id,
            }));

            setAllBranches(options);

        } catch (error) {
            console.log(error)
        }
    };


    const fetchStates = async () => {
        try {
            const res = await axios.get("https://api.skyguard.group/api/get-states");
            const options = res.data.map((state) => ({
                value: state,
                label: state,
            }));

            setStateOptions(options);

        } catch (error) {
            console.error("Error fetching states:", error);
        }
    };


    const fetchDataByState = async (state) => {
        if (!state) return;

        try {
            const response = await axios.get(
                `https://api.skyguard.group/api/get-state-data?state=${encodeURIComponent(state)}`
            );

            const data = response.data;
           
            if (!data || data.length === 0) {
                setStateData([]);
                setCityOptions([]);
                setPincodeOptions([]);
                showToast("No city available for this state", "warning");
                return;
            }

            setStateData(data);

            // unique cities
            const cityList = [...new Set(data.map(item => item.city))];

            const cityOptionsFormatted = cityList.map(city => ({
                value: city,
                label: city,
            }));

            const pincodeOptionsFormatted = data.map(item => ({
                value: item.pincode,
                label: item.pincode,
            }));


            setCityOptions(cityOptionsFormatted);
            setPincodeOptions(pincodeOptionsFormatted);

        } catch (error) {
            console.error("Error fetching cities by state:", error);
        }
    };



    useEffect(() => {
        fecthBranchDetail();
        fecthCompanyDetail();
        fetchDataByState();
        fetchStates();
    }, []);

    return (
        <div className='main-section'>
            <ToastNotification
                show={toast.show}
                message={toast.message}
                bg={toast.bg}
                onClose={() => setToast({ ...toast, show: false })}
            />
            <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
                <h3 className='my-3 fw-bold fs-5 golos'>Franchisee Branch Area</h3>
                <h2 className="text-center mb-4 fw-bold text-success">
                    Franchisee Area
                </h2>

                <div className="row justify-content-center">
                    <div className="col-12 col-md-8 col-lg-7">

                        <div className="card shadow-sm p-4 border-0">
                            <div className="card-body">

                                <form onSubmit={handleSubmit}>
                                    <div className='row ' >
                                        <div className='col-12 col-md-6 mb-2' >
                                            <label className='form-label fw-medium' >Franchisee Company </label>
                                            <Select
                                                options={company}
                                                value={selectedCompany}
                                                onChange={handleCompanyChange}
                                                placeholder="Select Company"
                                                isClearable
                                            />
                                        </div>

                                        <div className='col-12 col-md-6 mb-2' >
                                            <label className='form-label fw-medium'>Franchisee Branch </label>
                                            <Select
                                                options={branch}
                                                value={selectedBranch}
                                                onChange={setSelectedBranch}
                                                placeholder="Select branch"
                                                isClearable
                                            />
                                        </div>
                                        <div className="col-12 col-md-6  mb-2">
                                            <label className="form-label fw-medium">State</label>
                                            <Select
                                                options={stateOptions}
                                                value={selectedState}
                                                onChange={handleStateChange}
                                                placeholder="Select State"
                                                isClearable
                                            />
                                        </div>

                                        <div className="col-12 col-md-6  mb-2">
                                            <label className="form-label fw-medium">City</label>
                                            <Select
                                                options={cityOptions}
                                                value={selectedCity}
                                                // onChange={setSelectedCity}
                                                onChange={handleCityChange}
                                                placeholder="Select City"
                                                isClearable
                                                isDisabled={!selectedState}
                                            />
                                        </div>

                                        {cityTableData.length > 0 && (
                                            <div className="table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4">
                                                <table className="table table-bordered table-striped table-hover text-center align-middle">
                                                    <thead className='table-dark'>
                                                        <tr>
                                                            <th>Select</th>
                                                            <th>Region</th>
                                                            <th>Pincode</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>

                                                        {cityTableData.map((row, index) => {
                                                            const isChecked = (selectedRowsByCity[selectedCity?.value] || []).some(
                                                                item => String(item.pincode) === String(row.pincode)
                                                            );

                                                            return (
                                                                <tr key={index}>
                                                                    <td>
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={(selectedRowsByCity[selectedCity?.value] || []).some(
                                                                                item => String(item.pincode) === String(row.pincode)
                                                                            )}
                                                                            onChange={(e) => handleCheckboxChange(row, e.target.checked)}
                                                                        />

                                                                    </td>
                                                                    <td>{row.region}</td>
                                                                    <td>{row.pincode}</td>
                                                                </tr>
                                                            );
                                                        })}


                                                    </tbody>
                                                </table>

                                                <div className="col-12 d-flex justify-content-center gap-2 mt-3">
                                                    <button type="submit" className="btn btn-success">
                                                        Save
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn btn-secondary"
                                                        onClick={handleCancel}
                                                    >
                                                        Cancel
                                                    </button>
                                                </div>

                                            </div>
                                        )}


                                    </div>

                                </form>

                            </div>
                        </div>

                    </div>
                </div>

            </div>

        </div>
    )
}

export default FranchiseeArea